export const employeeHalfDayData = [
  {
    value: 0,
    label: 'Domingo',
    dayName: 'Sunday'
  },
  {
    value: 1,
    label: 'Lunes',
    dayName: 'Monday'
  },
  {
    value: 2,
    label: 'Martes',
    dayName: 'Tuesday'
  },
  {
    value: 3,
    label: 'Miércoles',
    dayName: 'Wednesday'
  },
  {
    value: 4,
    label: 'Jueves',
    dayName: 'Thursday'
  },
  {
    value: 5,
    label: 'Viernes',
    dayName: 'Friday'
  },
  {
    value: 6,
    label: 'Sábado',
    dayName: 'Saturday'
  }
]